import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Naples, FL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Naples can take 2–6 months, especially during busy travel seasons. For luxury travelers, seasonal residents, and retirees with upcoming cruises or European trips, that timeline is simply not viable.",
  },
  {
    q: "Can Naples seasonal residents expedite a passport quickly?",
    a: "Absolutely. Seasonal residents — snowbirds who split time between Naples and homes up north or abroad — are one of our most common client types. Many arrive in Southwest Florida only to discover their passport expired during the off-season. We can process expedited renewals and new applications on compressed timelines, so your winter escape or spring departure stays on schedule.",
  },
  {
    q: "What if my passport expires before an international cruise?",
    a: "This happens more often than you would think, especially in a cruise-heavy market like Naples. Most cruise lines require your passport to be valid for at least six months beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Naples post office typically takes 2–6 months — far too long for an upcoming sailing from Miami, Fort Lauderdale, or Tampa.",
  },
  {
    q: "Can I renew my passport fast before a Europe trip from Naples?",
    a: "Yes. Whether you are flying out of Southwest Florida International Airport (RSW) or connecting through a larger hub, we can process your renewal in as little as 2–9 business days depending on the service level you choose. Many Naples residents book European villa rentals, golf trips to Scotland, or business meetings in London on relatively short notice — our expedited service is designed for exactly that scenario.",
  },
  {
    q: "How quickly can travelers near Marco Island receive an expedited passport?",
    a: "Marco Island travelers have the same access to our expedited services as Naples residents. Since we operate remotely, your physical location in Southwest Florida does not affect processing speed. Ship your documents overnight from Marco Island, Bonita Springs, or Estero, and we handle the rest. Most Marco Island clients receive their passports within 2–9 business days.",
  },
  {
    q: "Can retired travelers expedite a passport renewal in Naples?",
    a: "Yes — retired and senior travelers are a significant portion of our Naples client base. Whether you are planning a Mediterranean cruise, a tour of French wine country, or a family reunion abroad, we make the renewal process straightforward. You do not need to drive to a passport agency or wait in long lines. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Naples travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Naples, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Naples or Southwest Florida area.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function NaplesFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Naples and Southwest Florida travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}